import React from 'react';
import helpers from '../Utils/helpers';
import SkynetIcon from "./Fundamentals/SkynetIcon";

export default function PhoneLink ({phoneNumber, label, button, classList}) {
    const formattedPhoneNumber = helpers.formatPhoneNumberForCountry(phoneNumber)
    let className = classList;
    let href = `tel:${formattedPhoneNumber}`;

    if (button)
        className += " btn btn-sm";

    if (!formattedPhoneNumber) {
        className += " disabled cursordefault";
        href = "";
    }

    return <a className={className} href={href}><SkynetIcon icon={"vismaicon-sm vismaicon-phone"}></SkynetIcon>{label}</a>
}